import { render } from "./DefaultFacet.vue?vue&type=template&id=7765f7c0&scoped=true"
import script from "./DefaultFacet.vue?vue&type=script&lang=js"
export * from "./DefaultFacet.vue?vue&type=script&lang=js"

import "./DefaultFacet.vue?vue&type=style&index=0&id=7765f7c0&lang=scss&scoped=true"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7765f7c0"]])

export default __exports__